import { ConversationPlatform } from "@redotech/redo-model/conversation";
import { TreatmentType } from "@redotech/redo-model/split";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getSupportAgentSplitsWithMetrics = {
  name: "getSupportAgentSplitsWithMetrics" as const,
  input: z.object({
    teamId: zExt.objectId().optional(),
    platforms: z.array(z.nativeEnum(ConversationPlatform)).optional(),
  }),
  output: z.array(
    z.object({
      splitId: zExt.objectId(),
      splitName: z.string(),
      team: z.object({ id: zExt.objectId(), name: z.string() }),
      active: z.boolean(),
      startDate: z.date(),
      endDate: z.date().nullable(),
      treatmentType: z.literal(TreatmentType.SUPPORT_AGENT),
      treatmentMetrics: z.array(
        z.object({
          _id: zExt.objectId(),
          name: z.string(),
          numConversations: z.number(),
          resolutionRevenue: z.number(),
          numResolved: z.number(),
          resolutionRate: z.number(),
          numEscalated: z.number(),
          escalationRate: z.number(),
          totalOrdersProduced: z.number(),
        }),
      ),
    }),
  ),
};
